import {useTranslation} from "react-i18next";
import {DocumentProps} from "./models";

export type OcrMode =
    | 'PLAIN_OCR'
    | 'MARKDOWN'
    | 'TABLES_MD'
    | 'DESCRIBE';

export type OcrFileStatus = 'PENDING' | 'PROCESSING' | 'SUCCESS' | 'ERROR';

export type OcrFileContentType = "PDF" | "PNG" | "JPEG" | "JPG";
export type OcrFileExportFormat = 'TXT' | 'DOCX' | 'PDF';

export type ExportableFile = OcrProcessedFile | OcrBatchFileResponse;

// currently only 'mode' is changeable
export interface OcrOptions {
    mode: OcrMode;
    grounding: boolean;
    include_caption: boolean;
    base_size: number;
    image_size: number;
    crop_mode: boolean;
    test_compress: boolean;
}

// POST /ocr/process
export interface OcrResultPage {
    pageNumber: number;
    text: string;
}
// GET /ocr/conversation/{id}/file/{fileId}
export interface OcrBatchFileResponse {
    fileId: number;
    fileName: string;
    status: OcrFileStatus;
    mode: OcrMode;
    contentType: OcrFileContentType;
    baseContent: string;
    size: number;
    pages: OcrResultPage[];
}

export interface OcrProcessedFile {
    id?: number;
    fileName: string;
    status: OcrFileStatus;
    mode?: OcrMode;
    contentType: OcrFileContentType;
    size: number;
    pages: OcrResultPage[] | null;
}
///

// POST /ocr/conversation
export interface OcrBatchIdResponse {
    id: number;
    title: string;
    createdAt: Date;
    pinned: boolean;
    pinOrder: number;
}
///

// GET /ocr/conversation/{id}
export interface OcrBatchVariant {
    id: number;
    timestamp: Date;
    content: string;
    active: boolean;
    documents?: DocumentProps[];
    usedTools?: string[];
}

export interface OcrBatchMessage {
    id: number;
    author: string;
    files: OcrProcessedFile[];
}

export interface OcrBatchResponse {
    id: number; // id conversation
    selectedModelId: number | null; // id modelu AI
    lastAnswerVariants: OcrBatchVariant[];
    messages: OcrBatchMessage[];
}
///

export const DEFAULT_OCR_OPTIONS: OcrOptions = {
    mode: 'PLAIN_OCR',
    grounding: false,
    include_caption: false,
    base_size: 1024,
    image_size: 640,
    crop_mode: true,
    test_compress: false,
};

export const useOcrModeLabels = (): Record<OcrMode, { label: string; description: string }> => {
    const { t } = useTranslation();
    return {
        PLAIN_OCR: {
            label: t('ocr.mode.plainOcr'),
            description: t('ocr.mode.plainOcrDescription'),
        },
        MARKDOWN: {
            label: t('ocr.mode.markdown'),
            description: t('ocr.mode.markdownDescription'),
        },
        TABLES_MD: {
            label: t('ocr.mode.tablesMd'),
            description: t('ocr.mode.tablesMdDescription'),
        },
        DESCRIBE: {
            label: t('ocr.mode.describe'),
            description: t('ocr.mode.describeDescription'),
        },
    };
};